module.exports = __webpack_public_path__ + "img/curve_lg.252de330.svg";